/* global moment */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackOffersEditController', WinbackOffersEditController);

    WinbackOffersEditController.$inject = ['debug', '$stateParams', 'i18n', 'API', 'helpers', '$state', 'alert',];

    function WinbackOffersEditController(debug, $stateParams, i18n, API, helpers, $state, alert) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.offer = {
            translations: {},
        };
        vm.subscriptionPlans = [];
        vm.loadingState = {
            offerIsLoading: false,
            subscriptionPlans: false,
        };
        vm.now = helpers.getDatabaseDatetime();
        vm.openRemoveModal = openRemoveModal;

        activate();

        function activate() {
            loadOffer();
            loadSubscriptionPlans();
        }

        function loadOffer() {
            vm.loadingState.offerIsLoading = true;
            API.WinbackOffer.get({ id: vm.id, expand: 'subscriptionPlan' }).$promise.then(function (response) {

                if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(response.free_until)) {
                    response.free_until = moment(response.free_until).toDate();
                }

                angular.extend(vm.offer, response);

                vm.loadingState.offerIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function loadSubscriptionPlans() {
            vm.loadingState.subscriptionPlans = true;
            API.SubscriptionPlan.search({ provider: 'Stripe', 'per-page': -1 }).$promise.then(function (response) {
                angular.extend(vm.subscriptionPlans, response.items);

                vm.loadingState.subscriptionPlans = false;
            }, function () {});
        }

        function save() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            var offer = angular.copy(vm.offer);

            if (offer.free_until) {
                offer.free_until = moment(offer.free_until).format('YYYY-MM-DD 00:00:00');
            }

            API.WinbackOffer.save({}, offer).$promise.then(function (response) {
                if (response.id) {
                    angular.extend(vm.offer, response);
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadOffer();
                }
            }, function () {
            })
                .finally(function () {
                    vm.isSaving = false;
                });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function () {
                var removePromise = API.WinbackOffer.recycle({ id: vm.id }).$promise;

                removePromise.then(function () {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('USER_RECYCLED') });
                    $state.go('winbackOffers.list');
                }, function () {
                });
            }, function () {
            });
        }
    }
})();